import React, { useState } from 'react';
import PageableTable from '../PageableTable';
import { ClientDto } from '../../../types';
import SecretButton, { SecretButtonState } from '@/components/button/SecretButton';

const ClientsTable: React.FC<{ clients: ClientDto[] }> = ({ clients }) => {
  const headers = ['Client ID', 'Grant Types', 'Owner', 'Scopes', ''];
  const [buttonStates, setButtonStates] = useState<{ [id: string]: SecretButtonState }>({});
  const handleSecretStateChange = (id: string, state: SecretButtonState) => {
    setButtonStates((prevStates) => ({
      ...prevStates,
      [id]: state,
    }));
  };
  const renderRow = (client: ClientDto, index: number) => (
    <tr key={index}>
      <td>{client.clientId}</td>
      <td>{client.grantTypes ? client.grantTypes.join(', ') : 'N/A'}</td>
      <td>{client.owner}</td>
      <td>{client.scopes ? client.scopes.join(', ') : 'N/A'}</td>
      <td>
        <SecretButton
          key={client.clientId}
          id={client.clientId}
          loading={buttonStates[client.clientId]?.loading}
          secret={buttonStates[client.clientId]?.secret}
          error={buttonStates[client.clientId]?.error}
          onStateChange={handleSecretStateChange}
        />
      </td>
    </tr>
  );

  return <PageableTable data={clients} headers={headers} renderRow={renderRow} itemsPerPage={20} />;
};

export default ClientsTable;
